<template>
    <ui-PanelOverlay
        panel="thermostat"
        :show="show"
        :modeHeat="modeHeat"
        :outService="outService"
        :outServiceLabel="outServiceLabel"
    >
        <template v-slot:menuBar>
            <slot name="menuBar"></slot>
        </template>
        <template v-slot:head>
            <ui-Title :name="name" :subName="ubication" :icoTarget="typeSpace"></ui-Title>
            <div class="info">
                <div>
                    <i class="value">{{ $castMetric(temperaturaValue) }}º</i>
                    <i class="label">{{ temperaturaLabel }}</i>
                </div>
                <div v-if="consignaShow">
                    <i class="value">{{ $castMetric(consignaValue) }}º</i>
                    <i class="label">{{ consignaLabel }}</i>
                </div>
                <div v-if="humedadValue">
                    <i class="value">{{ humedadValue }}%</i>
                    <i class="label">{{ humedadLabel }}</i>
                </div>
                <div>
                    <i class="value" :data-icoTarget="modeIcoTarget"></i>
                    <i class="label">{{ modeLabel }}</i>
                </div>
            </div>
        </template>
        <template v-slot:body v-if="programming">
            <slot name="bodyProgramming"></slot>
        </template>
        <template v-slot:body v-else>
            <slot name="body"></slot>
        </template>
    </ui-PanelOverlay>
</template>

<script>
    import ui_PanelOverlay from './ui-PanelOverlay.vue';
    import ui_Title from './ui-Title.vue';

    export default {
        extends: ui_PanelOverlay,
        components: {
            ui_Title,
        },
        name: 'ui-PanelThermostat',
        data: function() {
            return {};
        },
        props: {
            name: String,
            ubication: String,
            typeSpace: String,
            temperaturaLabel: String,
            temperaturaValue: Number,
            consignaShow: Boolean,
            consignaLabel: String,
            consignaValue: Number,
            humedadLabel: String,
            humedadValue: Number,
            modeLabel: String,
            modeIcoTarget: String,
            programming: {
                type: Boolean,
                default: false,
            },
        },
        methods: {},
        computed: {},
    };
</script>
